import React from "react";
import {
  LuArrowRight,
  LuFilePenLine,
  LuGraduationCap,
  LuHouse,
} from "react-icons/lu";
import "./AdmissionProcess.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

function AdmissionProcess() {
  return (
     <>
      <Navbar />
        <PageHeader
                    title="Admission Procedure"
                    crumbs={[
                      { label: "Home", href: "/" },
                      { label: "Admission Procedure" },
                    ]}
                  />
    <section className="admission-process-section" aria-labelledby="admission-process-title">
      <div className="admission-process-bg" aria-hidden="true" />

      <div className="admission-process-container">
   

      
        <div className="admission-process-card">
          <div className="admission-process-left-icon" aria-hidden="true">
            <LuGraduationCap />
          </div>

          <div className="admission-process-copy">
            <p>
              Gain entry into one of the top MCA Master in Computer Application courses with our streamlined admission process, guided by the directives of the State Common Entrance Test Cell (CET Cell), Admission Regulating Authority (ARA), Directorate of Technical Education (DTE), Maharashtra State.
            </p>

            <p>
              Our Master in Computer Application admission procedure ensures transparency and adherence to regulatory standards, ensuring a fair and efficient selection process for aspiring students.
            </p>
          </div>

          <div className="admission-process-divider" aria-hidden="true" />

          <div className="admission-process-action">
            <div className="admission-process-orbit" aria-hidden="true">
              <LuFilePenLine />
            </div>

            <a className="admission-process-button" href="/pdf/Home/Admission-Process-2024-25-1.pdf">
              <span>Admission Process</span>
              <LuArrowRight aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
          <Footer />
    </>
  );
}

export default AdmissionProcess;
